export default __webpack_public_path__ + "5496df38b8ca8c7736a9419188ed9bdf.svg";